import styles from './Battery.module.scss';

export default function Battery({ value }) {
  return (
    <div className={styles.container}>
      <div className={styles.value} style={{ width: `${value}%` }} />
    </div>
  );
}